import { cn } from 'src/shared/utils/cn'

type GeneralInfoSectionProps = {
  icon: React.ReactNode
  title: string
  subtitle?: string
  text?: string
  type?: 'mobile' | 'default'
  className?: string
  /** The container that contains the title and subtitle. */
  headingClassName?: string
}

const GeneralInfoSection = ({
  icon,
  title,
  subtitle,
  text,
  headingClassName = '',
  type = 'default',
  className = '',
}: GeneralInfoSectionProps) => {
  return (
    <div className={cn('flex flex-row items-start gap-3', className)}>
      <div className="w-[30px] lg:w-[35px]">{icon}</div>
      <div className="flex flex-col items-start justify-start">
        <div className={cn('flex flex-row items-center gap-2', headingClassName)}>
          <p
            className={cn(
              'text-base font-semibold text-primary lg:text-[17px]',
              type === 'mobile' && 'text-[15px] md:text-[16px]',
            )}
          >
            {title}
          </p>
          {subtitle && (
            <p
              className={cn(
                'text-[13px] font-semibold text-muted lg:text-sm',
                type === 'mobile' && 'text-[12px] md:text-[13px]',
              )}
            >
              {subtitle}
            </p>
          )}
        </div>
        {text && (
          <p className={cn('text-[13px] text-muted lg:text-sm', type === 'mobile' && 'text-[12px] md:text-[13px]')}>
            {text}
          </p>
        )}
      </div>
    </div>
  )
}

export default GeneralInfoSection
